module.exports = __webpack_public_path__ + "img/1Information.0db877a1.svg";